import {
	ITextOverflowHelperCounter,
	ITextOverflowHelperHTMLElementMapping,
	ITextOverflowHelperOptions,
	ITextOverflowHelperResponse,
} from '@kurtosys/types/helpers/index.js';

export class TextOverflowHelper {
	options: ITextOverflowHelperOptions;
	constructor(options?: ITextOverflowHelperOptions) {
		this.options = options || { mustStripStyle: false };
	}

	get(textWithHtml: string, options?: ITextOverflowHelperOptions): ITextOverflowHelperResponse {
		options = { ...this.options, ...(options || {}) };
		const { suffix, mustStripStyle } = options;

		if (suffix && options.length) {
			options.length -= suffix.length;
		}

		const container = document.createElement('div');
		container.innerHTML = mustStripStyle ? this.stripAttributeFromElements(textWithHtml, 'style') : textWithHtml;
		const elements: ITextOverflowHelperHTMLElementMapping[] = this.getMapping(container.childNodes);
		const counter = { current: 0, total: 0 };
		this.cleanElements(options, elements, counter);
		const content = this.rebuildContent(elements);
		return { counter, content };
	}
	getMapping(elements: NodeListOf<Node & ChildNode>): ITextOverflowHelperHTMLElementMapping[] {
		const collection: ITextOverflowHelperHTMLElementMapping[] = [];
		for (const element of Array.from(elements)) {
			const content: ITextOverflowHelperHTMLElementMapping = {
				element,
				text: element.textContent,
				tag: element.nodeName,
			};
			if (element.childNodes && element.childNodes.length > 0) {
				content.childNodes = this.getMapping(element.childNodes);
			}
			collection.push(content);
		}
		return collection;
	}
	stripAttributeFromElements(textWithHtml: string, attributes: string | string[], selector?: string): string {
		const container = document.createElement('div');
		container.innerHTML = textWithHtml;

		if (typeof attributes === 'string') {
			attributes = [attributes];
		}
		const selectorElements = selector && container.querySelectorAll(selector);
		for (const attribute of attributes) {
			const allElements = selectorElements || container.querySelectorAll(`[${attribute}]`);
			for (const element of Array.from(allElements)) {
				element.removeAttribute(attribute);
			}
		}
		return container.innerHTML;
	}
	cleanElements(
		options: ITextOverflowHelperOptions,
		elements: ITextOverflowHelperHTMLElementMapping[],
		counter: ITextOverflowHelperCounter = { current: 0, total: 0 },
	): boolean {
		const { length: maxLength, suffix } = options;
		let hasText = false;
		let lastIndex = -1;
		let index = -1;
		for (const element of elements) {
			index++;
			const availableLength = maxLength - counter.current;
			if (element.tag === '#text') {
				const textLength = element.text.length;
				counter.total += textLength;
				if (availableLength > 0) {
					if (availableLength >= textLength) {
						counter.current += textLength;
					} else if (availableLength < textLength) {
						element.text = `${element.text.substr(0, availableLength)}${suffix || ''}`;
						counter.current = maxLength;
					}
					lastIndex = index;
				} else {
					element.text = '';
				}
				element.element.textContent = element.text;
				hasText = hasText || element.text.length > 0;
				element.hasText = element.text.length > 0;
			}
			if (element.childNodes) {
				element.hasText = this.cleanElements(options, element.childNodes, counter);
				if (element.hasText) {
					lastIndex = index;
				}
				hasText = hasText || element.hasText;
			}
		}
		if (lastIndex > -1) {
			for (let i = lastIndex + 1; i < elements.length; i++) {
				const element = elements[i];
				const childElement = element.element;
				const parentElement = childElement.parentElement;
				if (parentElement) {
					try {
						parentElement.removeChild(childElement);
					} catch (error) {
						console.warn(
							`The use of UNSAFE collapse feature config for commentary app is causing this warning. We have limited control over the content loaded in this case.`,
						);
					}
				}
				elements.splice(i, 1);
				i--;
			}
		}
		return hasText;
	}
	rebuildContent(elements: ITextOverflowHelperHTMLElementMapping[]): string {
		const container = document.createElement('div');
		for (const element of elements) {
			container.appendChild(element.element);
		}
		return container.innerHTML;
	}
}
